import { render, staticRenderFns } from "./PopOrdersTable.vue?vue&type=template&id=50ec02bd&"
import script from "./PopOrdersTable.vue?vue&type=script&lang=js&"
export * from "./PopOrdersTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports